import BigNumber from 'bignumber.js';

export const getPercentFromBalance = (balance: string, percent: number) => {
  try {
    const percentFromMaxBalance = BigNumber(balance).times(percent).toNumber();
    return percentFromMaxBalance;
  } catch (e) {
    console.error(e);
    return 0;
  }
};
